// @flow

export default function(t: (name: string) => string) {
  return {
    announcement: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 4,
        description: t("SETTINGS_ANNOUNCEMENT_DESCRIPTION"),
      },
    },
    medicalOnly: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5,
        description: t("NON_MEDICAL_DESCRIPTION"),
      },
    },
    "ui:order": ["medicalOnly", "announcement", "*"],
  };
}
